import { GeneralIcon } from "gatsby-interface"
import { orgSettings as text } from "@modules/locales/default.json"

export const OrgSettingsSection = {
  General: `general`,
  Plan: `plan`,
  Status: `status`,
  Details: `details`,
}

export const OrgSettingsSectionLabel = {
  [OrgSettingsSection.General]: text.headers.general,
  [OrgSettingsSection.Plan]: text.headers.plan,
  [OrgSettingsSection.Status]: text.headers.status,
  [OrgSettingsSection.Details]: text.headers.details,
}

export const orgSettings = [
  {
    id: OrgSettingsSection.General,
    Icon: GeneralIcon,
    subsections: [
      {
        id: OrgSettingsSection.Details,
      },
      {
        id: OrgSettingsSection.Plan,
      },
      {
        id: OrgSettingsSection.Status,
      },
    ],
  },
]

/**
 * An object of this shape:
 * {
 *   [sectionId: string]: string | null
 * }
 * which allows to easily lookup if there is a parent section for provided section
 */
export const orgSettingsParentSections = orgSettings.reduce(
  (memo, { id: sectionId, subsections }) => {
    const nextValue = {
      ...memo,
      [sectionId]: null,
    }

    if (!subsections || subsections.length === 0) {
      return nextValue
    }

    const subsectionsParents = subsections.reduce((memo, subsection) => ({
      [subsection.id]: sectionId,
    }))

    return {
      ...nextValue,
      ...subsectionsParents,
    }
  },
  {}
)
